import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { OP_STATUS } from "../../../../util/varibles/constants";

interface IProps {
    step: number

    changeStep(step: any): void
}

const CurrentProcess: React.FC<IProps> = ({ step, changeStep }) => {
    const [data] = useTrackingOp(state => state.op?.operation);
    const { current_process = 0, status } = data || {};

    if (step === current_process || status !== OP_STATUS.PROCESSING)
        return <div />

    return <button className='h-[34px]' onClick={() => changeStep(current_process)}>
        Jump to current step
    </button>;
};

export default CurrentProcess;